import * as React from "react";
import {ChangeEvent} from "react";
import TextAreaAutoResize from "../../TextAreaAutoResize";
import IDifferentialDiagnosis from "../../../models/IDifferentialDiagnosis";
import {isEmpty as _isEmpty} from "lodash"

/**
 * Created by aditya on 15/03/18.
 */

export interface PatientDifferentialDiagnosisEditorProps {
    updatedDifferentialDiagnosis: {item: IDifferentialDiagnosis},
    updateDifferentialDiagnosis: (updatedDiagnosis: {item: IDifferentialDiagnosis}) => void;
    doctorType: string,
    curefitUserId: string
}

class PatientDifferentialDiagnosisEditor extends React.Component<PatientDifferentialDiagnosisEditorProps> {

    constructor(props: PatientDifferentialDiagnosisEditorProps) {
        super(props);
    }

    // showPatientDetailsSummary = (): boolean => {
    //     if (!_isEmpty(this.props.patientComplaints.complaints) || /*!_isEmpty(this.props.patientRedFlags) ||*/ !_isEmpty(this.props.patientHistory)) {
    //         return true;
    //     }
    //     return false;
    // }

    onDifferentialDiagnosisChange = (event: ChangeEvent<HTMLInputElement>) => {
        let currUpdatedDiagnosis: {item: IDifferentialDiagnosis} = { ...this.props.updatedDifferentialDiagnosis };
        currUpdatedDiagnosis.item.differentialDiagnosis = event.target.value;
        this.props.updateDifferentialDiagnosis(currUpdatedDiagnosis);
    }

    onNotesChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        let currUpdatedDiagnosis: {item: IDifferentialDiagnosis} = { ...this.props.updatedDifferentialDiagnosis };
        currUpdatedDiagnosis.item.notes = event.target.value;
        this.props.updateDifferentialDiagnosis(currUpdatedDiagnosis);
    }

    render() {
        let differentialDiagnosis = this.props.updatedDifferentialDiagnosis.item.differentialDiagnosis || "";
        let notes = this.props.updatedDifferentialDiagnosis.item.notes || "";
        return (
            <div className={"differential-diagnosis-editor"}>
                {/*<div className="ddx-section">
                    <div>DIFFERENTIAL DIAGNOSIS (If any)</div>
                    <div><TextInput value={differentialDiagnosis} name={"ddx-text-input"} placeholder={"E.g. Possibly Lupus?"} onChange={this.onDifferentialDiagnosisChange}/></div>
                </div>*/}
                <div className="summary-section">
                    <div>
                        {/*<TextInput value={notes} name={"ddx-text-input"} placeholder={"E.g. anything that will be useful for the next doctor"} onChange={this.onNotesChange}/>*/}
                        <TextAreaAutoResize
                            name={"differential-diagnosis-textarea"}
                            rows={3}
                            className={"case-summary-input"}
                            placeholder={"E.g. anything that will be useful for the next doctor"}
                            onChange={this.onNotesChange}
                            value={notes} 
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default PatientDifferentialDiagnosisEditor;